import React from "react";
import { Widget, CategoryWidget, BannerWidget } from "../../components";

// Widgets Data
import widgetsData from "../../data/widgets.json";
const { categoryList, workinghours } = widgetsData;

const SidebarTwo = ({ className }) => (
  <aside className={`service-sidebar ${className || ""}`}>
    <Widget widgetTitle="All Services" className="widget_nav_menu">
      <CategoryWidget>
        {categoryList.map((cat) => (
          <CategoryWidget.Item key={cat.title} path={cat.url}>
            {cat.title}
          </CategoryWidget.Item>
        ))}
      </CategoryWidget>
    </Widget>
    <Widget widgetTitle="Why Choose Us?" className="widget-workhours">
      <CategoryWidget>
        {workinghours.map((item, index) => (
          <CategoryWidget.Item key={index} path="/">
            <i className="fal fa-shield-check" />
            {item}
          </CategoryWidget.Item>
        ))}
      </CategoryWidget>
    </Widget>
    <Widget widgetTitle="Contact Info" className="widget_nav_menu">
      <CategoryWidget>
        <CategoryWidget.Item path="tel:+919167195907">
          <i className="fas fa-phone-alt" /> 9167195907
        </CategoryWidget.Item>
        <CategoryWidget.Item path="mailto:techsupport@techayukta.com">
          <i className="fas fa-envelope" /> techsupport@techayukta.com
        </CategoryWidget.Item>
        <CategoryWidget.Item path="/contact">
         <div className="d-flex"> <i className="fas fa-map-marker-alt" />  Accord Commercial Complex, Near BEST Bus Depot, Goregaon East, Mumbai – 400063</div>
        </CategoryWidget.Item>
      </CategoryWidget>
    </Widget>

    <BannerWidget
      title="Have Any Query?"
      image="/images/widget/quote-box.jpg"
      btnText="Get A Quote"
      path="/contact"
    />
  </aside>
);

export default SidebarTwo;
